import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { URLParamsProvider } from '../contexts/ParamsContext';

ReactDOM.render(
    <React.StrictMode>
        <URLParamsProvider>
            <App />
        </URLParamsProvider>
    </React.StrictMode>,
    document.getElementById('voxycure-editor')
);